import React from 'react'
import { Typography, Link } from '@mui/material';

const Adminsidebar = () => {
  return (
    <>
    <div className='sidebar-wrapper'>
        <div className='logo-wrapper'>
            <Typography variant='h2'>Aiims App</Typography>
        </div>
        <div className='daboard-menu-wrapper'>
            <Link href="Admin">Dashboard</Link>
            <Link href='/login'>Doctor Details</Link>
        </div>
    </div>
    </>
  )
}

export default Adminsidebar
